

const Minimize2 = ({ setIsMaximizeChatSize }) => {
  return (
    <button
      id="curatu-minimize-chat-window"
      title="Minimize Chat Window"
      className="hover:curai-ring-1 curai-hidden xs:curai-block max-h-400:curai-hidden hover:curai-ring-white focus:curai-box-border curai-border-none curai-text-white curai-bg-transparent curai-p-0"
      onClick={() => setIsMaximizeChatSize(true)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="4 14 10 14 10 20" />
        <polyline points="20 10 14 10 14 4" />
        <line x1="14" x2="21" y1="10" y2="3" />
        <line x1="3" x2="10" y1="21" y2="14" />
      </svg>
    </button>

  );
};

export default Minimize2;
